module.exports = __webpack_public_path__ + "static/media/hound.e19ab7a7.jpg";